import Highlights from '../components/highlights';
import Modal from "../components/modal";
import FormDownload from "../forms/download";
import FormComments from "../forms/comments";
import Comments from "../components/comments";
import { NavSlider, NavSliderItem } from "../components/nav-slider";
import { Slider, SliderItem } from "../components/slider";
import { ShareList, ShareLink } from "../components/social-share";

export default {
	name: 'BlogPost',
	components: {
		Modal,
		FormDownload,
		FormComments,
		NavSlider,
		NavSliderItem,
		Slider,
		SliderItem,
		Highlights,
		Comments,
		ShareList,
		ShareLink
	},
	data() {
		return {
			openDownload: false,
			highlight: null,
		};
	},
	methods: {
		generateCaptcha() {
			//hack to trigger form generateCaptcha()
			let openModal = this.$children.find(item => { return item.show == true })
			openModal.$children[0].generateCaptcha();
		},
	}
}
